export default {
    // apiBaseUrl:'https://activation.apps.we.bs',
    apiBaseUrl:'https://license.mobivone.com',
  };
  
